import { ShieldCheck, Clock, Users, Award } from 'lucide-react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } }
};

const stagger = {
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.2 } }
};

const badges = [
  {
    icon: Clock,
    text: '30+ Years Experience',
    testId: 'trust-badge-experience'
  },
  {
    icon: Users,
    text: 'Trusted by Thousands',
    testId: 'trust-badge-trusted'
  },
  {
    icon: ShieldCheck,
    text: 'Privacy Protected',
    testId: 'trust-badge-privacy'
  },
  {
    icon: Award,
    text: 'Licensed CPAs',
    testId: 'trust-badge-licensed'
  }
];

export const TrustBadges = () => {
  return (
    <motion.div
      variants={stagger}
      initial="hidden"
      animate="show"
      className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-8"
      data-testid="trust-badges-container"
    >
      {badges.map((badge) => {
        const Icon = badge.icon;
        return (
          <motion.div
            key={badge.testId}
            variants={fadeUp}
            className="flex items-center gap-2 text-white/60 text-sm"
            data-testid={badge.testId}
          >
            <Icon className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" />
            <span>{badge.text}</span>
          </motion.div>
        );
      })}
    </motion.div>
  );
};

export default TrustBadges;
